/** Copy of the saved views (2.K): one sentence per refusal, never a value. */
import { CATALOGUE_ISSUE_CODES } from '@codex/contracts';

const SAVE_COPY: Readonly<Record<string, string>> = {
  unknown_column: 'A column in this view no longer exists.',
  bad_operator: "A filter uses a comparison its column doesn't take.",
  bad_value: "A filter's value doesn't suit its column.",
  bad_cursor: 'The table changed while saving. Try again.',
  not_filterable: "A column in this view can't be filtered or sorted yet.",
  no_calendar: 'Set up the calendar before filtering by in-world date.',
  bad_world_date: "A filter's in-world date isn't in your calendar.",
  unknown_type: "This view's type no longer exists.",
  invalid_name: 'Give the view a name.',
  invalid_layout: 'Choose Table or List.',
};

export const SAVE_GENERIC = "The view couldn't be saved.";
export const CONFLICT_COPY = 'This view changed in another tab. Check it and update again.';

/** The sentence for a refusal's issue code in the Save and Rename dialogs. */
export function saveIssueCopy(code: string | null): string {
  return code !== null && Object.hasOwn(SAVE_COPY, code)
    ? (SAVE_COPY[code] as string)
    : SAVE_GENERIC;
}

/** Every catalogue code has a sentence here. */
export const COVERED_CODES: readonly string[] = CATALOGUE_ISSUE_CODES.filter((code) =>
  Object.hasOwn(SAVE_COPY, code),
);
